<template>
  <div>
    <GroupMasterLayout>
      <section class="overhead">
        <div
          class="overhead-1 d-flex justify-content-between py-5 wallet-header"
        >
          <div>
            <h5 class="">{{$t('text.iGroup.maintenance')}}</h5>

            <h6>{{$t('text.iGroup.viewMaintDetails')}}</h6>
          </div>
          <!-- <div class="col-md-4 date_picker_m">
            <div class="">
              <vue-ctk-date-time-picker
                v-model="dateRange"
                :max-date="maxDate"
                :range="true"
                :autoClose="true"
                :locale="this.$root.$i18n.locale"
                :custom-shortcuts="customShortcuts"
                color="#370F70"
                format="DDMMYYYY"
                formatted="DD/MM/YYYY"
                :label="$t('text.calendar.dateRange')"
              />
            </div>
          </div> -->
        </div>

        <div class="sub-nav">
          <ul class="d-flex">
            <li
              @click="() => (tabName = 'generators')"
              :class="tabName === 'generators' ? 'active-nav' : null"
              class="mr-5 pb-3 px-1"
            >
            {{$t('text.iGroup.allGenerators')}}
            </li>
            <li
              @click="() => (tabName = 'genService')"
              :class="tabName === 'genService' ? 'active-nav' : null"
            >
            {{$t('text.iGroup.serviceGen')}}
            </li>
          </ul>
        </div>
      </section>
      <GeneratorTab
        :dateRange="dateRange"
        :maxDate="maxDate"
        :startDate="startDate"
        :endDate="endDate"
        v-show="tabName === 'generators'"
      />
      <MaintenanceTab
        :dateRange="dateRange"
        :maxDate="maxDate"
        :startDate="startDate"
        :endDate="endDate"
        v-show="tabName === 'genService'"
      />
    </GroupMasterLayout>
  </div>
</template>

<script>
import GroupMasterLayout from "@/views/Industrial/GroupMasterLayout.vue";
import GeneratorTab from "./Generators";
import MaintenanceTab from "./Generator_Service";
export default {
  title: "Dashboard:: Epump Industrial Portal",
  name: "Maintenance",
  components: {
    GroupMasterLayout,
    GeneratorTab,
    MaintenanceTab,
  },
  data() {
    return {
      tabName: "generators",
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
    };
  },
};
</script>

<style scoped>
@media screen and (max-width: 575px) {
  .overhead-1 {
    flex-flow: column wrap !important;
  }
}
.wallet-header {
  width: 90%;
  margin: auto auto;
}

.overhead h5 {
  color: #2b2b2b;
  font-size: 35px;
}

.overhead ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 92%;
  margin: auto auto;
}

.sub-nav li {
  color: #2b2b2b;
  font-size: 14px;
  cursor: pointer;
}

.active-nav {
  color: #370f70 !important;
  border-bottom: 2px solid #370f70;
}

.sub-nav {
  width: 98%;
  margin: auto auto;
  border-bottom: 1px solid rgba(98, 98, 98, 0.2);
}
</style>
